import React from "react";
import GenericList from "../../components/lists/GenericList";
import { listFormFillers } from "../../actions/form-filler/listFormFillers";

const FormFillerList: React.FC<{
  refresh: boolean;
  onRefreshComplete: () => void;
}> = ({ refresh, onRefreshComplete }) => {
  return (
    <GenericList
      fetchData={listFormFillers}
      refresh={refresh}
      onRefreshComplete={onRefreshComplete}
    />
  );
};

export default FormFillerList;
